import * as React from "react";
import LinearProgress from "nx-components/LinearProgress";
import Theme from "nx-components/Theme";

const styles = {
  wrapper(context) {
    const leftSafePadding = context.isLargeAppLayout
      ? "0px"
      : Theme.Padding.SAFE_AREA_LEFT;
    return {
      marginBottom: "-4px", // LinearProgress is 4px high
      zIndex: "1",
      marginLeft: `calc(-1 * ${leftSafePadding})`,
      paddingLeft: leftSafePadding,
      marginRight: `calc(-1 * ${Theme.Padding.SAFE_AREA_RIGHT})`,
      paddingRight: Theme.Padding.SAFE_AREA_RIGHT,
    };
  },
};

// It's like LinearProgress, but it doesn't push stuff after it downwards.
// This is nice to use when the LinearProgress may appear and disappear, because
// when it (dis)appears, it won't change the flow of the page.
const OverlayLinearProgress = (props, context) => (
  <div style={styles.wrapper(context)}>
    <LinearProgress {...props} />
  </div>
);
OverlayLinearProgress.propTypes = {
  ...LinearProgress.propTypes,
};

export default OverlayLinearProgress;



// WEBPACK FOOTER //
// ./src/components/OverlayLinearProgress.jsx